// extracted by mini-css-extract-plugin
export default {"label":"FilterLabel_label__pAQI5","status":"FilterLabel_status__WHvKZ","icon":"FilterLabel_icon__1PU6v"};